// advance vacation salary payment task
export const SHORTAGE_CALUCLATION_LOAD = 'SHORTAGE_CALUCLATION_LOAD'
export const SHORTAGE_CALUCLATION_LOAD_PENDING = 'SHORTAGE_CALUCLATION_LOAD_PENDING'
export const SHORTAGE_CALUCLATION_LOAD_FULFILLED = 'SHORTAGE_CALUCLATION_LOAD_FULFILLED'
export const SHORTAGE_CALUCLATION_LOAD_REJECTED = 'SHORTAGE_CALUCLATION_LOAD_REJECTED'

export const SHORTAGE_CALUCLATION_UPDATE = 'SHORTAGE_CALUCLATION_UPDATE'
export const SHORTAGE_CALUCLATION_UPDATE_PENDING = 'SHORTAGE_CALUCLATION_UPDATE_PENDING'
export const SHORTAGE_CALUCLATION_UPDATE_FULFILLED = 'SHORTAGE_CALUCLATION_UPDATE_FULFILLED'
export const SHORTAGE_CALUCLATION_UPDATE_REJECTED = 'SHORTAGE_CALUCLATION_UPDATE_REJECTED'

export const IS_SHORTAGE_DEDUCTION_APPLICABLE_LOAD = 'IS_SHORTAGE_DEDUCTION_APPLICABLE_LOAD'
export const IS_SHORTAGE_DEDUCTION_APPLICABLE_LOAD_PENDING =
  'IS_SHORTAGE_DEDUCTION_APPLICABLE_LOAD_PENDING'
export const IS_SHORTAGE_DEDUCTION_APPLICABLE_LOAD_FULFILLED =
  'IS_SHORTAGE_DEDUCTION_APPLICABLE_LOAD_FULFILLED'
export const IS_SHORTAGE_DEDUCTION_APPLICABLE_LOAD_REJECTED =
  'IS_SHORTAGE_DEDUCTION_APPLICABLE_LOAD_REJECTED'

export const IS_SHORTAGE_DEDUCTION_APPLICABLE_UPDATE = 'IS_SHORTAGE_DEDUCTION_APPLICABLE_UPDATE'
export const IS_SHORTAGE_DEDUCTION_APPLICABLE_UPDATE_PENDING =
  'IS_SHORTAGE_DEDUCTION_APPLICABLE_UPDATE_PENDING'
export const IS_SHORTAGE_DEDUCTION_APPLICABLE_UPDATE_FULFILLED =
  'IS_SHORTAGE_DEDUCTION_APPLICABLE_UPDATE_FULFILLED'
export const IS_SHORTAGE_DEDUCTION_APPLICABLE_UPDATE_REJECTED =
  'IS_SHORTAGE_DEDUCTION_APPLICABLE_UPDATE_REJECTED'
